/**
 * Student codes follow: letters + "-" + numbers (e.g. AQ-001).
 * Search supports:
 * - substring match: "AQ-001", "001", "aq"
 * - inclusive range: "AQ-001 to AQ-049", "AQ-001 - AQ-049", "AQ-001:AQ-049", "AQ-001..AQ-049"
 */

const CODE_PATTERN = /^([a-zA-Z]+)-(\d+)$/;
const RANGE_PATTERN =
  /^([a-zA-Z]+)-(\d+)\s*(?:to|-|:|\.\.)\s*([a-zA-Z]+)-(\d+)$/i;

export function parseStudentCode(code) {
  const match = String(code ?? "").trim().match(CODE_PATTERN);
  if (!match) return null;
  return {
    prefix: match[1].toLowerCase(),
    number: Number.parseInt(match[2], 10),
  };
}

export function parseStudentCodeSearch(search) {
  const term = String(search ?? "").trim();
  if (!term) return { type: "empty" };

  const rangeMatch = term.match(RANGE_PATTERN);
  if (rangeMatch) {
    const prefixA = rangeMatch[1].toLowerCase();
    const prefixB = rangeMatch[3].toLowerCase();
    if (prefixA !== prefixB) {
      return { type: "includes", term: term.toLowerCase() };
    }

    let start = Number.parseInt(rangeMatch[2], 10);
    let end = Number.parseInt(rangeMatch[4], 10);
    if (start > end) [start, end] = [end, start];

    return { type: "range", prefix: prefixA, start, end };
  }

  return { type: "includes", term: term.toLowerCase() };
}

export function matchesStudentCodeSearch(userName, search) {
  const parsed = parseStudentCodeSearch(search);
  if (parsed.type === "empty") return true;

  const code = String(userName ?? "");

  if (parsed.type === "range") {
    const parts = parseStudentCode(code);
    if (!parts || parts.prefix !== parsed.prefix) return false;
    return parts.number >= parsed.start && parts.number <= parsed.end;
  }

  return code.toLowerCase().includes(parsed.term);
}
